import { Component } from '@angular/core';

@Component({
  selector: 'foc',
  templateUrl: './foc.template.html',
  standalone: false,
  styleUrls: ['./foc.style.scss']
})

export class Foc {

  constructor () {}

  ngOnInit() {
    
  }
}